import axios from 'axios';
import { installRequestId } from '../utils/requestId';
import { getMarketplaceApiBaseUrl, getMarketplaceDeployOrigin } from './resolveApiBaseUrl';

const API_BASE_URL = process.env.REACT_APP_SUBSCRIPTIONS_API_URL ||
  getMarketplaceApiBaseUrl() || 'http://localhost:8006/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,  // Send cookies with requests (httpOnly cookies)
});
installRequestId(api);

// Request interceptor - cookies are sent automatically by browser
api.interceptors.request.use(
  (config) => {
    // Cookies are automatically sent when withCredentials: true
    // No need to manually add Authorization header
    return config;
  },
  (error) => Promise.reject(error)
);

// Handle token refresh
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        // Refresh token is in httpOnly cookie, sent automatically
        // Use same domain for token refresh to ensure cookies are sent
        const accountsApiUrl = process.env.REACT_APP_API_BASE_URL ||
          getMarketplaceDeployOrigin() || 'http://localhost:8001';
        await axios.post(
          `${accountsApiUrl}/api/token/refresh/`,
          {},  // No body needed - refresh token in cookie
          { withCredentials: true }  // Send cookies
        );
        // New tokens are set in httpOnly cookies by backend
        // No need to read response - tokens in cookies automatically
        // Retry original request (cookies will be sent automatically)
        return api(originalRequest);
      } catch (refreshError) {
        // Only redirect to login if it's a persistent auth failure
        // Don't redirect on network errors or temporary issues
        if (refreshError.response?.status === 401 || refreshError.response?.status === 403) {
          // Redirect to login - cookies will be cleared by backend
          window.location.href = '/login';
        }
        return Promise.reject(refreshError);
      }
    }
    return Promise.reject(error);
  }
);

const DEPRECATED_ERROR = {
  error: 'Subscriptions are deprecated and no longer available.',
  code: 'SUBSCRIPTIONS_DEPRECATED',
};

export const subscriptionsAPI = {
  getSubscriptionPlans: async () => ({ plans: [], ...DEPRECATED_ERROR }),
  getMySubscription: async (_userId) => ({ subscription: null, ...DEPRECATED_ERROR }),
  checkoutSubscription: async () => {
    throw new Error(DEPRECATED_ERROR.error);
  },
  activateSubscription: async () => {
    throw new Error(DEPRECATED_ERROR.error);
  },
  cancelSubscription: async () => ({ success: false, ...DEPRECATED_ERROR }),
  getEntitlements: async (_userId) => ({ entitlements: {}, ...DEPRECATED_ERROR }),
};

export default subscriptionsAPI;

